// extracted by mini-css-extract-plugin
module.exports = {"section":"TaxesMainMobile_section__3p2Yb","logo":"TaxesMainMobile_logo__3XKMp"};